import React, { useEffect, useState } from "react";
import { Col, DatePicker, TimePicker } from "antd";
import moment from "moment";
import { ExamType } from "../../../../../service/exam";

interface TimeRangePickerProps {
    type: ExamType;
    start: string;
    end: string;
    onChange: (value: [string, string]) => void;
}

const format = "YYYY-MM-DD HH:mm";

export default function TimeRangePicker(props: TimeRangePickerProps) {
    const { type } = props;

    if (type === ExamType.Thesis) return <TimeRangePickerThesis {...props} />;
    return <TimeRangePickerOther {...props} />;
}

function TimeRangePickerThesis(props: TimeRangePickerProps) {
    const { type, start, end, onChange } = props;

    const [startDate, setStartData] = useState(
        start ? moment(start) : moment()
    );
    const [endData, setEndData] = useState(end ? moment(end) : moment());

    function disabledDate(current: moment.Moment | null): boolean {
        if (!current) return false;
        return current < moment().startOf("day");
    }

    useEffect(() => {
        onChange([startDate.format(format), endData.format(format)]);
    }, [startDate, endData]);

    return (
        <div style={{ display: "flex" }}>
            <DatePicker
                onChange={time => setStartData(time || moment())}
                value={moment(startDate, "YYYY-MM-DD HH:mm")}
                disabledDate={disabledDate}
                format="YYYY-MM-DD HH:mm"
                style={{ width: 157, minWidth: 157 }}
                allowClear={false}
                showTime={{ defaultValue: moment("00:00", "HH:mm") }}
            />

            <div style={{ textAlign: "center", width: 14 }}>-</div>

            <DatePicker
                onChange={time => setEndData(time || moment())}
                value={moment(endData, "YYYY-MM-DD")}
                disabledDate={disabledDate}
                format="YYYY-MM-DD HH:mm"
                style={{ width: 157, minWidth: 157 }}
                allowClear={false}
                showTime={{ defaultValue: moment("00:00", "HH:mm") }}
            />
        </div>
    );
}

function TimeRangePickerOther(props: TimeRangePickerProps) {
    const { start, end, onChange } = props;

    const [startDate, setStartData] = useState(
        start ? moment(start) : moment()
    );
    const [startTime, setStartTime] = useState(
        end ? moment(start) : moment("00:00", "HH:mm")
    );
    const [endTime, setEndTime] = useState(
        end ? moment(end) : moment("00:00", "HH:mm")
    );

    function disabledDate(current: moment.Moment | null): boolean {
        if (!current) return false;
        return current < moment().startOf("day");
    }

    useEffect(() => {
        onChange([
            startDate.format("YYYY-MM-DD ") + startTime.format("HH:mm"),
            startDate.format("YYYY-MM-DD ") + endTime.format("HH:mm")
        ]);
    }, [startDate, startTime, endTime]);

    return (
        <>
            <Col span={5}>
                <DatePicker
                    onChange={time => setStartData(time || moment())}
                    value={moment(startDate, "YYYY-MM-DD")}
                    disabledDate={disabledDate}
                    format="YYYY-MM-DD"
                    allowClear={false}
                    style={{ width: "100%", minWidth: 0 }}
                />
            </Col>

            <Col span={4} style={{ marginLeft: 10 }}>
                <TimePicker
                    value={startTime}
                    onChange={setStartTime}
                    format="HH:mm"
                    style={{ width: "100%", minWidth: 0 }}
                    allowClear={false}
                />
            </Col>

            <Col span={1} style={{ textAlign: "center", width: 14 }}>
                -
            </Col>

            <Col span={4}>
                <TimePicker
                    value={endTime}
                    onChange={setEndTime}
                    format="HH:mm"
                    style={{ width: "100%", minWidth: 0 }}
                    allowClear={false}
                />
            </Col>
        </>
    );
}
